import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path fill-rule=\"evenodd\" d=\"M13.228 3.421a2 2 0 0 0-2.456 0L2.388 9.942c-.752.585-.338 1.791.615 1.791H4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8h.997c.952 0 1.368-1.205.615-1.791l-8.384-6.52ZM15 19.733h3v-8.99c0-.317.146-.6.375-.785L12 5 5.625 9.958c.229.185.375.468.375.785v8.99h3v-5a3 3 0 0 1 6 0v5Zm-4 0h2v-5a1 1 0 0 0-2 0v5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol